export const MODAL_MODES = {
  ADD: 'ADD_MODE',
  EDIT: 'EDIT_MODE',
  VIEW: 'VIEW_MODE',
  CLONE: 'CLONE_MODE',
  DELETE: 'DELETE_MODE',
  IMPORT: 'IMPORT_MODE',
};
